import { render, staticRenderFns } from "./TripReview.vue?vue&type=template&id=2d5925a1&scoped=true"
import script from "./TripReview.vue?vue&type=script&lang=js"
export * from "./TripReview.vue?vue&type=script&lang=js"
import style0 from "./TripReview.vue?vue&type=style&index=0&id=2d5925a1&prod&lang=scss&scoped=true"
import style1 from "./TripReview.vue?vue&type=style&index=1&id=2d5925a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5925a1",
  null
  
)

export default component.exports